import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="container text-center mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h2 className="text-danger">🚫 {t("noAccess")}</h2>
            <p className="mt-3">
              {t("noAccessMessage")}            
            </p>
            <button className="btn btn-primary mt-3" onClick={() => navigate("/")}>
              🔙 {t("back")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
